import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './multilingual/i18n';
ReactDOM.render(React.createElement(React.Fragment, null,
    React.createElement(App, null)), document.getElementById('root'));
